import { useSelector } from "react-redux";

/**
 * Read current logged-in staff/user data from Redux auth state.
 * This is used for audit fields like AssignedBy.
 */
export const useStaffData = () => {
  const user = useSelector((state) => state.auth.user);
  return user?.userData || null;
};

/**
 * Best-effort "AssignedBy" value from current staff.
 * Prefers email, falls back to username.
 */
export const useAssignedBy = () => {
  const staff = useStaffData();
  return (
    staff?.email ||
    staff?.Email ||
    staff?.userEmail ||
    staff?.UserEmail ||
    staff?.userName ||
    staff?.UserName ||
    ""
  );
};

export default useStaffData;

